module.exports = __webpack_public_path__ + "img/1.8e95c263.png";